import Vue from 'vue'
const mutations = {
  initUserData (state) {
    state.userData = {}
  },
  setApiUrl (state, url) {
    state.apiUrl = url
  },
  setCurrentQuestion (state, path) {
    state.currentQuestion = state.questions.find(question => {
      return question.path === path
    })
  },
  setQuestions (state, questions) {
    state.questions = questions
  },
  updateUserData (state, payload) {
    Vue.set(state.userData, payload.key, payload.value)
  }
}

export default mutations
